import { store } from '../store/store'
import { buildCompareSnapshot, getDifficultyLabel, priceExIncFromSell } from './compareSnapshot'

/**
 * Compare drawer state API (Vue 2 + Vuex).
 */
export function useCompare () {
  return {
    get compareItems () {
      return store.getters['compare/compareItems']
    },
    get compareCount () {
      return store.getters['compare/compareCount']
    },
    get isFull () {
      return store.getters['compare/isFull']
    },
    get comparePreviewOpen () {
      return store.getters['compare/comparePreviewOpen']
    },
    addToCompare (task, sessionCompareKey, options = {}) {
      const multipliers = options.multipliers || []
      const sellPrice = options.sellPrice != null
        ? options.sellPrice
        : (task && task.sell_price)
      const difficultyLabel = options.difficultyLabel != null
        ? options.difficultyLabel
        : getDifficultyLabel(task && task.location, multipliers)
      const snapshot = buildCompareSnapshot(task, sellPrice, difficultyLabel)
      store.commit('compare/addToCompare', { snapshot, sessionCompareKey })
    },
    removeFromCompare (compareEntryId) {
      store.commit('compare/removeFromCompare', compareEntryId)
    },
    removeBySessionKey (sessionCompareKey) {
      store.commit('compare/removeBySessionKey', sessionCompareKey)
    },
    clearCompare () {
      store.commit('compare/clearCompare')
    },
    isInCompare (sessionCompareKey) {
      return store.getters['compare/isInCompare'](sessionCompareKey)
    },
    setComparePreviewOpen (open) {
      store.commit('compare/setComparePreviewOpen', open)
    },
    markAddedToQuote (compareEntryId) {
      store.commit('compare/markAddedToQuote', compareEntryId)
    },
    priceExIncFromSell
  }
}
